import CampaignCard from './CampaignCard';

export default CampaignCard;
